import { useContext } from "react";
import * as Ably from "ably";
import { AblyProvider, ChannelProvider } from "ably/react";
import { useFeatureFlag } from "../../../context/features";
import { SHOW_PAYMENT_MIGRATION } from "../../../context/features/features.utils";
import PaymentMatching from "./components/PaymentMatching";
import { AppContext } from "../../../context/app";
import { isDev, isProd, isStage, isLocal } from "../../../env";
import {
  ABLY_API_KEY_DEV,
  ABLY_API_KEY_PROD,
  ABLY_API_KEY_STAGE,
} from "../constants";

export default function PaymentMigration() {
  const app = useContext(AppContext);
  const { isFeatureEnabled } = useFeatureFlag();
  const showPaymentMigration =
    isFeatureEnabled(SHOW_PAYMENT_MIGRATION) || isLocal() || isDev();
  const mainPage = window.location.origin;

  const getAblyApiKey = () => {
    if (isProd()) return ABLY_API_KEY_PROD;
    if (isStage()) return ABLY_API_KEY_STAGE;
    return ABLY_API_KEY_DEV;
  };

  const client = new Ably.Realtime({
    key: getAblyApiKey(),
  });

  if (!showPaymentMigration) {
    window.location.href = `${mainPage}/migration-assistant/`;
  }

  return (
    <AblyProvider client={client}>
      <ChannelProvider
        channelName={`billing.${app.client.uuid}.payment.migration`}
      >
        <ChannelProvider
          channelName={`client.${app.client.uuid}.payment.migration`}
        >
          <PaymentMatching />
        </ChannelProvider>
      </ChannelProvider>
    </AblyProvider>
  );
}
